import {z} from "zod/v4-mini"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    curveGeometryAttributeSetLike,
    curveGeometryAttributeSetLikeMarker,
    meshGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike, meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode, MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeSetLikeNode, MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {JoinOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/join-operator/geometry-join-operator-node"
import {GeometryJoinOperatorNode, joinOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute-set/join-operator/geometry-join-operator-node"

export type CurveGeometryJoinOperatorParameters = JoinOperatorParameters<
    CurveGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode,
    CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<CurveGeometryJoinOperatorParameters> = {
    nodeClass: "CurveGeometryJoinOperator",
    validation: {
        parameters: joinOperatorParametersSchema(
            curveGeometryAttributeLike,
            curveGeometryAttributeSetLike,
            z.union([curveGeometryAttributeLike, meshGeometryAttributeLike]),
            z.union([curveGeometryAttributeSetLike, meshGeometryAttributeSetLike]),
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryJoinOperator
    extends GeometryJoinOperatorNode<
        1,
        CurveGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode,
        CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
    >
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 1 {
        return 1
    }
}
